<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Import </span> /
      <span> Progress </span>
    </nav>
    <import-steps></import-steps>

    <div class="container mt-5">
      <div class="my-5">
        <flow-progress :progress="progress"></flow-progress>
      </div>
      <h2 class="flow-heading">Import in progress...</h2>
      <p v-if="contacts" class="import-progress__stat">
        Importing <strong>{{ groups }}</strong> groups and <strong>{{ contacts }}</strong> contacts.
      </p>
      <p v-else class="import-progress__stat import-progress__stat--calculating">Calculating . . .</p>
      <div>
        <a class="btn btn-lg btn-outline-primary mr-2 mb-2" :class="{disabled: progress < 100}" :href="viewContactsHref"
          >View Contacts</a
        >
        <a class="btn btn-lg btn-primary mb-2" href="/inventory/contacts/imports/">Open Import History</a>
      </div>
    </div>
  </div>
</template>

<script>
import ImportSteps from '../components/import/ImportSteps';
import FlowProgress from '../components/shared/FlowProgress';
import {listenToPusherImportEvents} from '../utility/notifications/listenToPusherImportEvents';
import {importFromCrm} from '../utility/api/import/importFromCrm.js';

export default {
  name: 'import-progress-page',
  components: {ImportSteps, FlowProgress},
  data() {
    return {
      progress: 0,
      contacts: 0,
      groups: 0,
    };
  },
  props: {
    selectedGroupsIds: {
      type: String,
    },
    crm: {
      type: String,
    },
  },
  methods: {
    initializePusherImportEvents() {
      listenToPusherImportEvents(notification => {
        const {groups, contacts_received, contacts_processed} = notification.message.counts;
        this.groups = groups;
        this.contacts = contacts_received;
        this.progress =
          contacts_processed > this.progress
            ? Math.trunc((contacts_processed / contacts_received) * 100)
            : this.progress;

        if (notification.message.type === 'import-finished') {
          this.progress = 100;
          this.redirectToComplete();
        }
        if (notification.message.type === 'import-failed') {
          $.notify('Something went wrong! Import Failed!', 'error');
        }
      });
    },
    redirectToComplete() {
      window.location.href = `/import/complete/?contacts_href=${this.viewContactsHref}`;
    },
  },
  mounted() {
    this.initializePusherImportEvents();
    setTimeout(() => {
      importFromCrm(JSON.parse(this.selectedGroupsIds), this.crmName, this.queryData);
    }, 1000);
  },
  computed: {
    crmName() {
      const crm = JSON.parse(this.crm);
      return crm?.crm_name;
    },
    urlSearchParams() {
      return new URLSearchParams(window.location.search);
    },
    queryData() {
      return Object.fromEntries(this.urlSearchParams.entries());
    },
    viewContactsHref() {
      let href = '/inventory/';
      if (this.queryData['groupId']) {
        href += `contacts/groups/edit/${window.location.search}`;
      } else if (this.queryData['campaignId']) {
        href += `campaigns/subscribers/${window.location.search}`;
      } else {
        href += 'contacts/groups/';
      }
      return href;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.import-progress {
  &__stat {
    color: $mine-shaft-color;
    margin: 20px auto 30px;
    &--calculating {
      animation: blink 2s linear infinite;
    }
  }
  &__img {
    margin: 30px auto 0;
  }
}
@keyframes blink {
  50% {
    opacity: 0.2;
  }
}
</style>
